export const DOWNLOAD_YANDEX_APP =
  'https://8jxm.adj.st/route?tariffClass=express&adj_t=ivdp40_fxy409&&adj_campaign=ALL-ALL-ALL&adj_adgroup=share-route-card&adj_creative=oldbanner&adj_deep_link=yandextaxi%3A%2F%2Froute%3FtariffClass%3Dexpress'

export const DOWNLOAD_YANGO_APP = 'https://yango.go.link?adj_t=1fth5c10_1fy2neeo&adj_campaign=default_27_08_2024'
